export const INDEX_CONFIG = {
  "sp_500": "S&P 500",
  sp_500_russell_2000: "S&P 500/Russell 2000 (Lesser of)",
  "russell_2000": "Russell 2000",
  nasdaq: "Nasdaq 100",
  msci_eafe: "MSCI EAFE",
  msci_emerging_markets: "MSCI Emerging Markets",
  ishares: "iShares U.S. Real Estate ETF",
};

export const SEGMENT_CONFIG = {
  1: "1-Year",
  2: "2-Year",
  3: "3-Year",
  6: "6-Year",
};

export const BUFFER_CONFIG = {
  buffer_10: "-10% Buffer",
  buffer_15: "-15% Buffer",
  buffer_20: "-20% Buffer",
  buffer_25: "-25% Buffer",
  buffer_100: "-100% Buffer",
  trigger_30: "30% Trigger",
};

export const CATEGORY_CONFIG = {
  standard: "Standard",
  dual: "Dual Direction",
  annual_lock: "Annual Lock",
  contingent_return: "Contingent Return",
  /** Label only for legacy brochure cart entries; Income Choice is not selectable in the create-brochure flow. */
  income_choice: "Income Choice",
  annual_fee: "Standard with Annual Fee",
  dual_directional_w_annual_fee: "Dual Directional with Annual Fee",
};
